
<h2 mat-dialog-title>{{ data.title | translate }}
  <mat-checkbox class="checkboxAbstand"
                (change)="showInactive($event)"
  >

    {{ 'pages.zeitverwaltung.spesenverwaltung.showInactive' | translate }}</mat-checkbox>
  <div class="add-button-container">
    <button matTooltip="Spesenart Hinzufügen" (click)="addSpesenart()" mat-mini-fab color="warn" aria-label="Add a address" class="pluscolor">
      <mat-icon>add</mat-icon>
    </button>
  </div>

</h2>



<mat-dialog-content class="mat-typography">
  <app-spesenart-table [spesenart]="$spesenarten | async" ></app-spesenart-table>
</mat-dialog-content>
<mat-dialog-actions align="end">

  <button
    mat-raised-button
    color="accent"
    (click)="handleSubmitClick()"
  >
    {{ data.submitButtonLabel | translate }}
  </button>
</mat-dialog-actions>
